import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ScrollService } from 'src/app/services/scroll.service';
@Component({
  selector: 'app-relative-has-dementia',
  templateUrl: './relative-has-dementia.component.html',
  styleUrls: ['./relative-has-dementia.component.css'],
})
export class RelativeHasDementiaComponent implements OnInit, OnDestroy {
  lightText = '';
  darkText = '';
  cards: any[] = [
    {
      id: 'relative-has-dementia-4047',
      title: 'Як підготуватися до майбутнього',
      link: '/get-support/what-to-do-if/relative-has-dementia',
      dementiaMenuId: 2023,
    },
    {
      id: 'jrelative-has-dementia-4048',
      title: 'Як подбати про себе',
      link: '/get-support/what-to-do-if/relative-has-dementia',
      dementiaMenuId: 2023,
    },
    {
      id: 'relative-has-dementia-4050',
      title: 'Як реагувати на зміну поведінки у людини з деменцією',
      link: '/get-support/what-to-do-if/relative-has-dementia',
      dementiaMenuId: 2023,
    },
    {
      id: 'relative-has-dementia-4051',
      title: 'Як спілкуватися з близьким, що живе з деменцією',
      link: '/get-support/what-to-do-if/relative-has-dementia',
      dementiaMenuId: 2023,
    },
    {
      id: 'relative-has-dementia-4052',
      title: 'Організація догляду вдома',
      link: '/get-support/what-to-do-if/relative-has-dementia',
      dementiaMenuId: 2023,
    },
    {
      id: 'relative-has-dementia-4053',
      title: 'Фахова допомога з доглядом',
      link: '/get-support/what-to-do-if/relative-has-dementia',
      dementiaMenuId: 2023,
    },
  ];
  sectionCards: any[] = [];
  currentBreadcrumb: string | null = 'second';
  isLoaded = false;
  private routeSubscription: Subscription | null = null;

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private scrollService: ScrollService,
  ) {}

  ngOnInit(): void {
    this.routeSubscription = this.route.params.subscribe(params => {
      const routeId = params['secondId'];
      this.router.navigate([], { state: { id: routeId } });
      this.fetchCardList()
        .pipe(
          tap((data: any[]) => {
            this.lightText = data[0].contentLight;
            this.darkText = data[0].contentDark;

            this.sectionCards = data[0].menuSubTitle.map((el: any) => ({
              subMenuCards: [
                ...el.SubMenuCards.map((card: any) => ({
                  link:
                    '/get-support/what-to-do-if/relative-has-dementia/' +
                    card.cardId,
                  cardTitle: card.cardTitle,
                })),
              ],
            }));

            this.currentBreadcrumb = data[0].menuTitle;
            const element = document.querySelector(
              '[data-breadcrumb="second"]',
            );
            if (element) {
              element.innerHTML = data[0].menuTitle;
            }
            this.scrollService.setLoaded(true);
          }),
        )
        .subscribe();
    });
  }

  fetchCardList(): Observable<any[]> {
    const url = `https://nezabutni-backend.vercel.app/api/second-page?id=relative-has-dementia`;
    return this.http.get<any[]>(url);
  }
  ngOnDestroy(): void {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }
}
